import { FC } from 'react'
import { useTodayAdPlayCount } from '../hooks/useTodayAdPlayCount'

interface TodayAdPlayCountProps {
  broadcastDeviceId: number
  supplierId?: number
}

const TodayAdPlayCount: FC<TodayAdPlayCountProps> = ({ broadcastDeviceId, supplierId }) => {
  const { count, isLoading } = useTodayAdPlayCount({ broadcastDeviceId, supplierId })
  return (
    <div className="flex-1 flex flex-col items-center justify-center border rounded px-2 py-1">
      <div className="text-xs text-muted-foreground mb-1">當日播放次數</div>
      <span className="text-2xl font-bold">{isLoading ? '-' : count}</span>
    </div>
  )
}

export default TodayAdPlayCount
